import { ICONS } from "../../../constants/icons";
import { classNames } from "../../../lib/class-names";

import "./icon.scss";

type IconPropsT = {
  name: string;
  size: number | string;
  className?: string;
};
const Icon: React.FC<IconPropsT> = ({ name, size, className }: IconPropsT) => {
  const SvgIcon = ICONS[name];

  const iconClasses = classNames({
    icon: true,
    ...(className ? { [className]: !!className } : {}),
  });

  return <SvgIcon width={size} height={size} className={iconClasses} aria-hidden focusable="false" />;
};

export default Icon;
